import React from "react";
import { Heart, Award, Clock, Smile } from "lucide-react";

const stats = [
  { icon: Heart, value: "100%", label: "Hecho con amor" },
  { icon: Award, value: "Premium", label: "Ingredientes selectos" },
  { icon: Clock, value: "24-48h", label: "Tiempo de entrega" },
  { icon: Smile, value: "∞", label: "Clientes felices" },
];

// Carrusel comentado — descomenta cuando tengas las imágenes listas
// const carouselImages = [
//   { src: "/carousel/torta1.jpg", alt: "Torta personalizada 1" },
//   { src: "/carousel/torta2.jpg", alt: "Torta personalizada 2" },
//   { src: "/carousel/torta3.jpg", alt: "Torta personalizada 3" },
//   { src: "/carousel/torta4.jpg", alt: "Torta personalizada 4" },
// ];

const About: React.FC = () => {
  return (
    <section
      id="about"
      className="py-12 md:py-20 relative bg-transparent"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-14 reveal">
          <p className="font-body text-xs text-rose-500 tracking-[0.3em] uppercase font-medium mb-3">
            Nuestra historia
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-semibold text-rose-900 mb-6 leading-tight">
            Un sueño convertido en
            <br className="hidden md:block" /> dulce realidad
          </h2>
          <p className="font-body text-rose-700/75 text-base leading-relaxed max-w-2xl mx-auto mb-3">
            Estef's Cakes nació de la pasión por convertir cada celebración en
            un momento único e inolvidable. Cada torta es elaborada
            artesanalmente con ingredientes de primera calidad.
          </p>
          <p className="font-body text-rose-700/75 text-base leading-relaxed max-w-2xl mx-auto">
            Ubicados en Puerto La Cruz, llevamos alegría y sabor a cada rincón
            de la ciudad y sus alrededores.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-14 reveal">
          {stats.map(({ icon: Icon, value, label }, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-5 flex flex-col items-center text-center gap-3 border border-rose-100 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-11 h-11 rounded-2xl bg-rose-50 flex items-center justify-center">
                <Icon className="w-5 h-5 text-rose-600" />
              </div>
              <div>
                <p className="font-display text-2xl font-bold text-rose-900">
                  {value}
                </p>
                <p className="font-body text-xs text-rose-500 font-medium">{label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
